import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';

const ConfirmationModal = ({ header, onClose, submitAction, isOpen }) => {
  if (!isOpen) return null;

  return (
    <Modal onClose={onClose}>
      <div className="confirmation-modal-container">
        <p className="header-text">{header}</p>
        <button className="submit-button active" onClick={submitAction}>
          Yes
        </button>
      </div>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  header: PropTypes.string,
  onClose: PropTypes.func,
  submitAction: PropTypes.func,
  isOpen: PropTypes.bool,
};

export default memo(ConfirmationModal);
